<footer id="page-footer" class="opacity-0" style="opacity: 1;">
    <div class="content py-20 font-size-xs clearfix">

      <div class="">
          lectionaryweb © <span class="js-year-copy">2017</span> Trinity Church Wall Street. All Rights Reserved. Lectionary resources are used under agreement with copyright owners.
          <a routerLink="/copyright"  tabindex="-1">
            <i class="icon icon-lg fa fa-info-circle"></i>
          </a>
      </div>
    </div>
</footer>
